import { useQuery } from '@tanstack/react-query'
import { seriesKeys } from '@/api/queryKeys'
import { fetchSeries } from '@/api/series'

/**
 * Hook to fetch all series with optional filters
 *
 * @param params - Query parameters for filtering
 * @returns React Query result with series list data
 *
 * @example
 * ```tsx
 * const { data, isLoading, error } = useSeries({ searchText: 'guard', limit: 20 });
 * ```
 */
export function useSeries(params?: {
  searchText?: string
  limit?: number
  offset?: number
  includeRelations?: boolean
}) {
  return useQuery({
    queryKey: seriesKeys.list(params ?? {}),
    queryFn: () => fetchSeries(params ?? {}),
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
